angular.module('gym.mobile_app').directive('mobileAppSettingsEventLocations', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/event_locations.html.slim'),
    controller: ["$scope", "$window", "MobileApp", "Locations", function($scope, $window, MobileApp, Locations) {
      var loadLocations;
      loadLocations = function() {
        return Locations.getList({
          count: 1000
        }).then(function(locations) {
          return $scope.locations = _.sortBy(locations, function(location) {
            return !location.active;
          });
        });
      };
      loadLocations();
      $scope.displayName = function(location) {
        if (location.active) {
          return location.name;
        } else {
          return `[Deactivated] ${location.name}`;
        }
      };
      $scope.addLocation = function() {
        return $scope.newLocation = {};
      };
      $scope.cancel = function() {
        return $scope.newLocation = void 0;
      };
      $scope.saveLocation = function(location) {
        if ($scope.isUpdating) {
          return;
        }
        $scope.isUpdating = true;
        location.save().then(function() {
          loadLocations();
          return $scope.isUpdating = false;
        });
        return function() {
          return $scope.isUpdating = false;
        };
      };
      $scope.resetLocation = function(location) {
        angular.extend(location, $scope.tempLocation);
        return location._edit = void 0;
      };
      $scope.editLocation = function(location) {
        $scope.tempLocation = angular.extend({}, location.plain());
        return location._edit = true;
      };
      $scope.createLocation = function() {
        if (!$scope.newLocation.name || $scope.isCreating) {
          return;
        }
        $scope.isCreating = true;
        return Locations.post($scope.newLocation).then(function() {
          $scope.isCreating = false;
          $scope.error = void 0;
          $scope.newLocation = void 0;
          return loadLocations();
        }, function() {
          return $scope.isCreating = false;
        });
      };
      $scope.reactivateLocation = function(location) {
        if ($window.confirm("Reactivate this location?")) {
          location.active = true;
          return $scope.saveLocation(location);
        }
      };
      return $scope.deleteLocation = function(location) {
        if ($window.confirm("Are you sure?")) {
          $scope.error = void 0;
          return location.remove().then(function() {
            return loadLocations();
          }, function() {
            return $scope.error = 'This location is in use and cannot be deleted at this time.';
          });
        }
      };
    }]
  };
});
